
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const [selectedProduct, setSelectedProduct] = useState('all');
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  const products = [
    {
      id: 1,
      name: '温泉美肌フェイスクリーム',
      category: 'cosmetics',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20face%20cream%20jar%20with%20natural%20hot%20spring%20minerals%2C%20elegant%20white%20and%20gold%20packaging%2C%20spa-like%20setting%20with%20bamboo%20and%20stones%2C%20soft%20natural%20lighting%2C%20premium%20skincare%20product%20photography%2C%20clean%20minimalist%20background&width=400&height=400&seq=1&orientation=squarish',
      description: '天然温泉ミネラルを配合した贅沢なフェイスクリーム'
    },
    {
      id: 2,
      name: '源泉入浴剤セット',
      category: 'bath',
      image: 'https://readdy.ai/api/search-image?query=Natural%20hot%20spring%20bath%20salts%20in%20elegant%20glass%20bottles%2C%20Japanese%20spa%20aesthetic%2C%20bamboo%20and%20stone%20elements%2C%20soft%20warm%20lighting%2C%20premium%20bath%20product%20packaging%2C%20clean%20white%20background&width=400&height=400&seq=2&orientation=squarish',
      description: '本格的な温泉気分を自宅で楽しめる入浴剤'
    },
    {
      id: 3,
      name: '温泉ミネラル美容液',
      category: 'cosmetics',
      image: 'https://readdy.ai/api/search-image?query=Premium%20serum%20bottle%20with%20hot%20spring%20mineral%20essence%2C%20elegant%20dropper%20design%2C%20spa%20environment%20with%20natural%20stones%20and%20water%2C%20luxury%20skincare%20photography%2C%20soft%20natural%20lighting%2C%20clean%20background&width=400&height=400&seq=3&orientation=squarish',
      description: '温泉の恵みを凝縮した高濃度美容液'
    },
    {
      id: 4,
      name: 'リラックス入浴剤',
      category: 'bath',
      image: 'https://readdy.ai/api/search-image?query=Relaxing%20bath%20products%20with%20lavender%20and%20hot%20spring%20minerals%2C%20peaceful%20spa%20setting%2C%20soft%20purple%20and%20white%20tones%2C%20natural%20elements%2C%20premium%20bath%20salt%20packaging%2C%20serene%20background&width=400&height=400&seq=4&orientation=squarish',
      description: 'ラベンダーと温泉成分でリラックス効果抜群'
    },
    {
      id: 5,
      name: '温泉ハンドクリーム',
      category: 'cosmetics',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20hand%20cream%20tube%20with%20hot%20spring%20minerals%2C%20Japanese%20spa%20aesthetic%2C%20natural%20bamboo%20and%20stone%20setting%2C%20soft%20lighting%2C%20premium%20skincare%20packaging%2C%20clean%20minimalist%20background&width=400&height=400&seq=5&orientation=squarish',
      description: '手肌に優しい温泉ミネラル配合'
    },
    {
      id: 6,
      name: 'デトックス入浴剤',
      category: 'bath',
      image: 'https://readdy.ai/api/search-image?query=Detox%20bath%20salts%20with%20natural%20hot%20spring%20minerals%2C%20green%20tea%20elements%2C%20spa%20environment%20with%20natural%20stones%2C%20healthy%20wellness%20aesthetic%2C%20premium%20packaging%2C%20clean%20background&width=400&height=400&seq=6&orientation=squarish',
      description: '温泉成分と緑茶エキスでデトックス効果'
    }
  ];

  const filteredProducts = selectedProduct === 'all' 
    ? products 
    : products.filter(product => product.category === selectedProduct);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20hot%20spring%20onsen%20with%20natural%20rocks%20and%20steaming%20water%2C%20serene%20mountain%20landscape%2C%20traditional%20wooden%20elements%2C%20peaceful%20spa%20atmosphere%2C%20soft%20morning%20light%2C%20zen%20aesthetic%2C%20natural%20beauty&width=1920&height=1080&seq=7&orientation=landscape')`
        }}
      >
        <div className="text-center text-white px-4 w-full">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            ONSEN Factory
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            天然温泉源泉を活用した製品開発・OEM製造サービス
            <br />
            あなたのブランドに温泉の恵みを
          </p>
          <button 
            onClick={handleContactClick}
            className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            お問い合わせ・相談
          </button>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">
                温泉の力を、あなたの製品に
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                ONSEN Factory株式会社は日本の美しい温泉地から採取した天然源泉を使用し、 
                お客様のブランドに合わせたコスメティック製品と入浴剤の開発・製造を行っています。
              </p>
              <p className="text-lg text-gray-600 mb-8">
                豊富な経験と技術力で、企画から製造まで一貫したOEMサービスを提供し、 
                お客様のビジネス成功をサポートします。
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">100%</div>
                  <div className="text-gray-600">天然温泉源泉</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">無添加</div>
                  <div className="text-gray-600">化学物質不使用</div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Natural%20hot%20spring%20minerals%20and%20crystals%20arranged%20beautifully%2C%20spa%20wellness%20products%2C%20Japanese%20aesthetic%20with%20bamboo%20and%20stones%2C%20soft%20natural%20lighting%2C%20premium%20skincare%20ingredients%2C%20clean%20white%20background&width=600&height=600&seq=8&orientation=squarish"
                alt="温泉ミネラル"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              開発可能な製品ラインナップ
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              温泉の恵みを活かした、コスメティックと入浴剤の開発・製造を承ります
            </p>
          </div>

          {/* Product Filter */}
          <div className="flex justify-center mb-12">
            <div className="bg-white rounded-full p-2 shadow-md">
              <button
                onClick={() => setSelectedProduct('all')}
                className={`px-6 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  selectedProduct === 'all' 
                    ? 'bg-teal-600 text-white' 
                    : 'text-gray-600 hover:text-teal-600'
                }`}
              >
                すべて
              </button>
              <button
                onClick={() => setSelectedProduct('cosmetics')}
                className={`px-6 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  selectedProduct === 'cosmetics' 
                    ? 'bg-teal-600 text-white' 
                    : 'text-gray-600 hover:text-teal-600'
                }`}
              >
                コスメティック
              </button>
              <button
                onClick={() => setSelectedProduct('bath')}
                className={`px-6 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  selectedProduct === 'bath' 
                    ? 'bg-teal-600 text-white' 
                    : 'text-gray-600 hover:text-teal-600'
                }`}
              >
                入浴剤
              </button>
            </div>
          </div>

          {/* Product Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product) => (
              <div key={product.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              私たちのサービス
            </h2>
            <p className="text-lg text-gray-600">
              企画から製造まで、一貫したOEMサービスを提供
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center bg-white p-8 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                製品企画・開発
              </h3>
              <p className="text-gray-600">
                お客様のご要望に合わせて、温泉成分を活用した製品の企画・開発を行います
              </p>
            </div>

            <div className="text-center bg-white p-8 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-flask-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                処方開発・試作
              </h3>
              <p className="text-gray-600">
                専門技術者による処方開発と試作品製造で、理想の製品を実現します
              </p>
            </div>

            <div className="text-center bg-white p-8 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-factory-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                OEM製造
              </h3>
              <p className="text-gray-600">
                小ロットから大量生産まで、品質管理を徹底したOEM製造サービス
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              温泉成分の美容効果
            </h2>
            <p className="text-lg text-gray-600">
              天然温泉に含まれるミネラルがもたらす、様々な美容効果
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-drop-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                保湿効果
              </h3>
              <p className="text-gray-600">
                温泉ミネラルが肌の水分バランスを整え、しっとりとした肌を保ちます
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-pulse-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                血行促進
              </h3>
              <p className="text-gray-600">
                温泉成分が血行を促進し、健康的で輝く肌へと導きます
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                リラックス効果
              </h3>
              <p className="text-gray-600">
                天然の香りと成分が心身をリラックスさせ、ストレスを軽減します
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-teal-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            温泉の恵みを活用した製品開発をお考えですか？
          </h2>
          <p className="text-xl text-teal-100 mb-8">
            お客様のブランドに最適な製品開発をサポートいたします
          </p>
          <button 
            onClick={handleContactClick}
            className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            お問い合わせ・相談
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-8">会社情報</h3>
            <div className="space-y-4 text-gray-300">
              <div>
                <span className="font-semibold">社名：</span>
                ONSEN Factory株式会社
              </div>
              <div>
                <span className="font-semibold">代表取締役：</span>
                多田 登
              </div>
              <div>
                <span className="font-semibold">住所：</span>
                宮崎県小林市南西方９６５ー１４
              </div>
              <div>
                <span className="font-semibold">電話番号：</span>
                050-3701-6178
              </div>
              <div>
                <span className="font-semibold">メールアドレス：</span>
                info@onsenfactory.co.jp
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 ONSEN Factory株式会社. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
